// src/js/config/dependencyManager.js

function getCheckboxByFunction(featureId) {
    const row = document.querySelector(`tr[data-feature-id="${featureId}"]`);
    return row ? row.querySelector('input[type="checkbox"]') : null;
}

function evaluateRule(rule) {
    if (typeof rule === 'string') {
        const cb = getCheckboxByFunction(rule);
        return cb ? cb.checked : false;
    }
    if (rule.type === 'and' || rule.type === 'custom') {
        return rule.dependsOn.every(dep => evaluateRule(dep));
    } else if (rule.type === 'or') {
        return rule.dependsOn.some(dep => evaluateRule(dep));
    }
    return false;
}

/**
 * Evaluerar alla funktionsberoenden.
 * Uppgraderad för att hantera både delvis och helt logikstyrda rader.
 */
function evaluateDependencies() {
    const dependencyMatrix = window.SimP?.DATA?.dependencyMatrix;
    if (!dependencyMatrix) {
        console.warn("Dependency matrix not found. Skipping evaluation.");
        return;
    }

    for (const [target, rule] of Object.entries(dependencyMatrix)) {
        const targetCheckbox = getCheckboxByFunction(target);
        if (!targetCheckbox) continue;

        const parentRow = targetCheckbox.closest('tr');
        const isFullyControlled = parentRow && parentRow.dataset.logicControlled === 'true';

        const shouldBeChecked = evaluateRule(rule);
        
        // ### NY LOGIK FÖR FALL A och B ###
        if (isFullyControlled) {
            // FALL A: Helt logikstyrd. Måste alltid vara disabled.
            targetCheckbox.disabled = false; // Aktivera tillfälligt för att kunna ändra värde
            targetCheckbox.checked = shouldBeChecked;
            targetCheckbox.disabled = true;  // Inaktivera omedelbart igen
        } else {
            // FALL B: Delvis logikstyrd. Rör bara checked-status.
            targetCheckbox.checked = shouldBeChecked;
        }
    }
}

export const DependencyManager = {
    evaluateDependencies: evaluateDependencies
};